import { render } from "./Tabs.vue?vue&type=template&id=55c1b175"
const script = {}

import exportComponent from "/Users/cb-it-01-1886/Documents/Chargbe Design/cb-payments-vue/transaction/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__